import React, { FC, useMemo } from "react";

import { IGrade, IClass } from "../../../state.d";
import Button from "../../../atoms/ActiveLearning/Button";
import { ReactComponent as IconClass } from "../../../assets/images/Class/icon_class.svg";
import styles from "../Select.module.scss";

import ClassGroup from "./ClassGroup";

export type Props = {
  classes: IClass[];
  forward?: boolean;
  forwardData?: boolean;
  isMultiSelect?: boolean;
  selectedClassIds?: number[];
  selectedClasses?: IClass[];
  onChooseClass?: (id: number) => void;
  onRemoveClass?: (id: number) => void;
  goToTextbookWithSelectedClasses?: () => void;
};

const Class: FC<Props> = ({
  classes,
  forward = false,
  forwardData = false,
  isMultiSelect = false,
  selectedClassIds = [],
  selectedClasses = [],
  onChooseClass,
  onRemoveClass,
  goToTextbookWithSelectedClasses,
}) => {
  const classList = useMemo(() => {
    const grades: IGrade[] = [];
    classes.forEach(cls => {
      if (!grades.find(item => item.grade === cls.grade)) {
        grades.push({
          grade: cls.grade,
          classes: [
            {
              id: cls.id,
              name: cls.full_name,
              charged: cls.charged,
              assumed_entrance_year: cls.assumed_entrance_year,
            },
          ],
        });
      } else {
        const index = grades.findIndex(item => item.grade === cls.grade);
        grades[index].classes.push({
          id: cls.id,
          name: cls.full_name,
          charged: cls.charged,
          assumed_entrance_year: cls.assumed_entrance_year,
        });
      }
    });
    return grades;
  }, [classes]);

  return (
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.inner}>
            <p className={styles.title}>
              <IconClass />
              クラスを選んでください
            </p>
            <div className={styles.content}>
              <ClassGroup
                gradeList={classList}
                forward={forward}
                forwardData={forwardData}
                selectedClassIds={selectedClassIds}
                onChooseClass={onChooseClass}
              />
            </div>
          </div>
        </div>
        {isMultiSelect && (
          <div className={styles.footer}>
            <div className={styles.inner}>
              <p className={styles.heading}>選択中のクラス</p>
              <div className={styles.content}>
                <div className={styles.classList}>
                  {selectedClasses.map(cls => (
                    <div
                      key={cls.id}
                      className={styles.item}
                      onClick={() => onRemoveClass?.(cls.id)}
                    >
                      <span className={styles.name}>{cls.full_name}</span>
                    </div>
                  ))}
                </div>
                <div style={{ flexShrink: 0 }}>
                  <Button
                    width={"116px"}
                    height={"38px"}
                    fontSize={"14px"}
                    handleClick={goToTextbookWithSelectedClasses}
                    disabled={selectedClassIds.length === 0}
                  >
                    クラスを確定
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Class;
